import { ApiService } from '../../../../ApiService';
import { FilterState } from '../../../../../containers/applicant_tracking/Analytics/Filters';
import { mapToParams } from '../../mapToParams';

export class ExportsService {
  public static pdf(filterState?: FilterState): Promise<Blob> {
    return ApiService.get(
      '/applicant_tracking/analytics/pipeline_performance/exports/pdf',
      mapToParams(filterState),
    );
  }

  public static csv(filterState?: FilterState): Promise<Blob> {
    return ApiService.get(
      '/applicant_tracking/analytics/pipeline_performance/exports/csv',
      mapToParams(filterState),
    );
  }
}
